import {
  HttpClient,
  HttpClientModule,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';

import { AppComponent } from './app.component';
import { AppRoutes } from './app.routing';
import { SharedModule } from './shared/shared.module';
import { CustomHttpInterceptor } from './utilities/CustomHttpInterceptor';
import { UtilitiesService } from './utilities/utilities.service';
import { SkuDataService } from './services/sku-data.service';
import { FilterDataService } from './services/filter-data.service';
import { AlertService } from './services/alert.service';
import { AlertComponent } from './directives/alert/alert.component';
import { environment } from 'src/environments/environment';
import { ApplicationInitializationService } from './services/application-initialization.service';

import { CommonModule } from '@angular/common';
import { NgOtpInputModule } from 'ng-otp-input';
@NgModule({
  declarations: [
    AppComponent,
    AlertComponent

  ],
  imports: [
    BrowserModule,
    NgOtpInputModule,
    IonicModule.forRoot(),
    AppRoutes,
    SharedModule,
    CommonModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
 
    LoadingBarRouterModule,
    LoadingBarHttpClientModule,
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CustomHttpInterceptor,
      multi: true,
    },
    { provide: 'googleTagManagerId', useValue: 'GTM-TSZ46Z' },
    UtilitiesService,
    SkuDataService,
    FilterDataService,
    AlertService,
    { 
      provide : APP_INITIALIZER, 
      multi : true, 
      deps : [ApplicationInitializationService], 
      useFactory : (applicationInitializationService : ApplicationInitializationService) => () => applicationInitializationService.initializeApp()
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, environment.HOST + '/b2c/einitiative-app/assets/i18n/', '.json');
  // return new TranslateHttpLoader(http);
}
